import published from "../../content/published.json";
import assets from "../../content/assets.json";
import { parseBrandContent, resolveBrandLogo } from "./content";

// Bundled into the approved UI bytes. No browser call to Publisher.
export const commandBrand = parseBrandContent(published);

export const commandLogo = resolveBrandLogo(commandBrand, assets);
